module.exports = __webpack_public_path__ + "assets/images/HEP-logo-small.png";